import React from 'react'
import { useTranslate } from '../TranslationText'
import NewActionButton from '../ActionButtons/NewActionButton';
import { eformFormButton } from '../../common/cssclasses';

export default function DraftBtn({ ...props }) {
    const { translate } = useTranslate();
    return (
        <div className={eformFormButton}>
            <NewActionButton
                isSubmitBtn

                classNames="btn-outline-secondary"
                text={
                    <>
                        <i className=" fa fa-save"></i>
                        {translate("web.draft", "Draft")}
                    </>
                }
                {...props}
            />
        </div>
    )
}
